module.exports = __webpack_public_path__ + "img/4_147.b1d70b4b.png";